import React, { Component } from "react";
import { ChevronLeft, ChevronRight } from 'lucide-react';

class Pagination extends Component {
    render() {
        const { currentPage, totalPages, onPageChange } = this.props;
        if (totalPages <= 1) return null;

        const maxPagesToShow = 5;
        const pages = [];
        let startPage = 1;
        let endPage = totalPages;

        if (totalPages > maxPagesToShow) {
            const half = Math.floor(maxPagesToShow / 2);
            startPage = Math.max(currentPage - half, 1);
            endPage = Math.min(currentPage + half, totalPages);

            if (endPage - startPage < maxPagesToShow - 1) {
                if (currentPage <= half) {
                    endPage = maxPagesToShow;
                } else {
                    startPage = totalPages - maxPagesToShow + 1;
                }
            }
        }

        return (
            <div className="mza-pagination">
                <button
                    className="mza-pagination__btn mza-pagination__btn--arrow"
                    disabled={currentPage === 1}
                    onClick={() => onPageChange(currentPage - 1)}
                >
                    <ChevronLeft size={16} />
                </button>

                {startPage > 1 && (
                    <>
                        <button className="mza-pagination__btn" onClick={() => onPageChange(1)}>1</button>
                        {startPage > 2 && <span className="mza-pagination__dots">…</span>}
                    </>
                )}

                {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
                    <button
                        key={page}
                        className={`mza-pagination__btn ${page === currentPage ? 'mza-pagination__btn--active' : ''}`}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </button>
                ))}

                {endPage < totalPages && (
                    <>
                        {endPage < totalPages - 1 && <span className="mza-pagination__dots">…</span>}
                        <button className="mza-pagination__btn" onClick={() => onPageChange(totalPages)}>{totalPages}</button>
                    </>
                )}

                <button
                    className="mza-pagination__btn mza-pagination__btn--arrow"
                    disabled={currentPage === totalPages}
                    onClick={() => onPageChange(currentPage + 1)}
                >
                    <ChevronRight size={16} />
                </button>
            </div>
        );
    }
}

export default Pagination;